export enum ActionType {
  VIEW = "view",
  EDIT = "edit",
  CREATE = "create"
}
